import { AutoComplete } from './AutoComplete';
export default AutoComplete;
export var Option = AutoComplete.Option;
